export var EAccountStatus;
(function (EAccountStatus) {
    EAccountStatus[EAccountStatus["\u5168\u90E8\u72B6\u6001"] = -1] = "\u5168\u90E8\u72B6\u6001";
    EAccountStatus[EAccountStatus["\u5F85\u63D0\u4EA4"] = 0] = "\u5F85\u63D0\u4EA4";
    EAccountStatus[EAccountStatus["\u5DF2\u63D0\u4EA4"] = 7] = "\u5DF2\u63D0\u4EA4";
    EAccountStatus[EAccountStatus["\u5F85\u5BA1\u6838"] = 1] = "\u5F85\u5BA1\u6838";
    EAccountStatus[EAccountStatus["\u5DF2\u5BA1\u6838"] = 2] = "\u5DF2\u5BA1\u6838";
    EAccountStatus[EAccountStatus["\u5F85\u4ED8\u6B3E"] = 3] = "\u5F85\u4ED8\u6B3E";
    EAccountStatus[EAccountStatus["\u5DF2\u4ED8\u6B3E"] = 4] = "\u5DF2\u4ED8\u6B3E";
    EAccountStatus[EAccountStatus["\u5DF2\u5E9F\u5F03"] = 5] = "\u5DF2\u5E9F\u5F03";
    EAccountStatus[EAccountStatus["\u53CD\u5BA1\u6838"] = 6] = "\u53CD\u5BA1\u6838";
})(EAccountStatus || (EAccountStatus = {}));
export default EAccountStatus;
